import { ViewModel, View, ObservableArray } from "binder"
import moment from "moment";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { getAsNumber } from "src/uicomponents/components/utilities";
import { ServerSideDataLoader, PaginationInfo } from "uicomponents";
import { AttachmentDownloader } from "../attachmentFileDownloader";
import { CreatePaymentOrderViewModel } from "../createPaymentOrder/createPaymentOrder-viewModel";
import { processStateEnumProvider, processTypeEnumProvider, TransactionTransferTypeEnumProvider } from "../processStateEnumProvider";
import { PaymentOrdersListView } from "./paymentOrdersList-view"
import { translate } from "src/common/utilities";

export class PaymentOrdersListViewModel extends WindowViewModel {
    public getTitle(): string {
        return translate("paymentOrdersList-viewModel.paymentOrders", {});
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.paymentRequests = ObservableArray.create<singlePaymentRequest>();
        this.stateEnumProvider = new processStateEnumProvider();
        this.typeEnumProvider = new processTypeEnumProvider();
        this.transactionTypeEnumProvider = new TransactionTransferTypeEnumProvider();
        this.loader = new ServerSideDataLoader(filteringInformation => this.refreshPaged(filteringInformation), 30);
        this.refresh();
    }
    GetDefaultView(): View<ViewModel> {
        return new PaymentOrdersListView();
    }
    public getTypeId(): string {
        return "VM-897689F1-2A8A-4629-B0CE-83424984CE15"
    }


    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader; } private _loader: ServerSideDataLoader;
    public set paymentRequests(v: ObservableArray<singlePaymentRequest>) { this._paymentRequests = v; } public get paymentRequests(): ObservableArray<singlePaymentRequest> { return this._paymentRequests; } private _paymentRequests: ObservableArray<singlePaymentRequest>;
    public set stateEnumProvider(v: processStateEnumProvider) { this._stateEnumProvider = v; } public get stateEnumProvider(): processStateEnumProvider { return this._stateEnumProvider; } private _stateEnumProvider: processStateEnumProvider;
    public set typeEnumProvider(v: processTypeEnumProvider) { this._typeEnumProvider = v; } public get typeEnumProvider(): processTypeEnumProvider { return this._typeEnumProvider; } private _typeEnumProvider: processTypeEnumProvider;
    public set transactionTypeEnumProvider(v: TransactionTransferTypeEnumProvider) { this._transactionTypeEnumProvider = v; } public get transactionTypeEnumProvider(): TransactionTransferTypeEnumProvider { return this._transactionTypeEnumProvider; } private _transactionTypeEnumProvider: TransactionTransferTypeEnumProvider;


    refresh() {
        this.loader.refresh();
    }
    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/PaymentProcessServices/GetAllPaymentProcesses', {
                FurtherQueryInfo: filteringInformation
            });
            this.paymentRequests.update(...result.Requests.map((x, i) => {
                let r = new singlePaymentRequest(this);
                r.index = i + 1;
                r.requestId = x.RequestId;
                r.orderId = x.OrderId;
                r.licenseId = x.LicenseId;
                r.processId = x.ProcessId;
                r.requestCode = x.RequestNo;
                r.orderCode = x.OrderNo;
                r.licenseCode = x.LicenseNo;
                r.transactionCode = x.TransactionCode;
                r.accountingTransaction1Code = x.AccountingTransaction1Code;
                r.accountingTransaction2Code = x.AccountingTransaction2Code;
                r.amount = x.Amount;
                r.requestComment = x.RequestComment;
                r.orderComment = x.OrderComment;
                r.licenseComment = x.LicenseComment;
                r.requestType = x.RequestType;
                r.status = x.Status;
                r.forPerson = x.PersonName;
                r.transactionType = x.TransactionTransferType;
                r.requestCreationTime = x.RequestCreationTime == null ? null : moment.utc(x.RequestCreationTime);
                r.orderCreationTime = x.OrderCreationTime == null ? null : moment.utc(x.OrderCreationTime);
                r.licenseCreationTime = x.LicenseCreationTime == null ? null : moment.utc(x.LicenseCreationTime);
                r.requestAttachments.update(...x.RequestAttachments.map(q => {
                    let r2 = new attachment(r);
                    r2.id = q.Id;
                    r2.name = q.Name;
                    return r2;
                }));
                r.orderAttachments.update(...x.OrderAttachments.map(q => {
                    let r2 = new attachment(r);
                    r2.id = q.Id;
                    r2.name = q.Name;
                    return r2;
                }));
                r.licenseAttachments.update(...x.LicenseAttachments.map(q => {
                    let r2 = new attachment(r);
                    r2.id = q.Id;
                    r2.name = q.Name;
                    return r2;
                }));

                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage, result.PaginationInfo.PageCount);

        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0, 0);
        } finally {
            this.isLoading = false;
        }
    }
}

export class singlePaymentRequest extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: PaymentOrdersListViewModel) {
        super(parent);
        this._parent = parent;
        this.requestAttachments = ObservableArray.create<attachment>();
        this.orderAttachments = ObservableArray.create<attachment>();
        this.licenseAttachments = ObservableArray.create<attachment>();
        this.showDetail = false;
    }
    public set index(v: number) { this._index = v; } public get index(): number { return this._index; } private _index: number;

    public set requestId(v: string) { this._requestId = v; } public get requestId(): string { return this._requestId; } private _requestId: string;
    public set orderId(v: string) { this._orderId = v; } public get orderId(): string { return this._orderId; } private _orderId: string;
    public set licenseId(v: string) { this._licenseId = v; } public get licenseId(): string { return this._licenseId; } private _licenseId: string;
    public set processId(v: string) { this._processId = v; } public get processId(): string { return this._processId; } private _processId: string;

    public set requestCode(v: string) { this._requestCode = v; } public get requestCode(): string { return this._requestCode; } private _requestCode: string;
    public set orderCode(v: string) { this._orderCode = v; } public get orderCode(): string { return this._orderCode; } private _orderCode: string;
    public set licenseCode(v: string) { this._licenseCode = v; } public get licenseCode(): string { return this._licenseCode; } private _licenseCode: string;
    public set transactionCode(v: string) { this._transactionCode = v; } public get transactionCode(): string { return this._transactionCode; } private _transactionCode: string;
    public set accountingTransaction1Code(v: string) { this._accountingTransaction1Code = v; } public get accountingTransaction1Code(): string { return this._accountingTransaction1Code; } private _accountingTransaction1Code: string;
    public set accountingTransaction2Code(v: string) { this._accountingTransaction2Code = v; } public get accountingTransaction2Code(): string { return this._accountingTransaction2Code; } private _accountingTransaction2Code: string;


    public set amount(v: number) { this._amount = getAsNumber(v, true); } public get amount(): number { return this._amount; } private _amount: number;
    public set requestComment(v: string) { this._requestComment = v; } public get requestComment(): string { return this._requestComment; } private _requestComment: string;
    public set orderComment(v: string) { this._orderComment = v; } public get orderComment(): string { return this._orderComment; } private _orderComment: string;
    public set licenseComment(v: string) { this._licenseComment = v; } public get licenseComment(): string { return this._licenseComment; } private _licenseComment: string;

    public set requestCreationTime(v: moment.Moment) { this._requestCreationTime = v; } public get requestCreationTime(): moment.Moment { return this._requestCreationTime; } private _requestCreationTime: moment.Moment;
    public set orderCreationTime(v: moment.Moment) { this._orderCreationTime = v; } public get orderCreationTime(): moment.Moment { return this._orderCreationTime; } private _orderCreationTime: moment.Moment;
    public set licenseCreationTime(v: moment.Moment) { this._licenseCreationTime = v; } public get licenseCreationTime(): moment.Moment { return this._licenseCreationTime; } private _licenseCreationTime: moment.Moment;

    public set forPerson(v: string) { this._forPerson = v; } public get forPerson(): string { return this._forPerson; } private _forPerson: string;
    public set requestType(v: number) { this._requestType = getAsNumber(v); } public get requestType(): number { return this._requestType; } private _requestType: number;
    public set status(v: number) {
        this._status = getAsNumber(v);
        this.updateShowingActions();
    } public get status(): number { return this._status; } private _status: number;

    public set requestAttachments(v: ObservableArray<attachment>) { this._requestAttachments = v; } public get requestAttachments(): ObservableArray<attachment> { return this._requestAttachments; } private _requestAttachments: ObservableArray<attachment>;
    public set orderAttachments(v: ObservableArray<attachment>) { this._orderAttachments = v; } public get orderAttachments(): ObservableArray<attachment> { return this._orderAttachments; } private _orderAttachments: ObservableArray<attachment>;
    public set licenseAttachments(v: ObservableArray<attachment>) { this._licenseAttachments = v; } public get licenseAttachments(): ObservableArray<attachment> { return this._licenseAttachments; } private _licenseAttachments: ObservableArray<attachment>;

    public set transactionType(v: number) { this._transactionType = v; } public get transactionType(): number { return this._transactionType; } private _transactionType: number;
    public set showDetail(v: boolean) { this._showDetail = v; } public get showDetail(): boolean { return this._showDetail; } private _showDetail: boolean;
    public set shallShowCretePaymentOrder(v: boolean) { this._shallShowCretePaymentOrder = v; } public get shallShowCretePaymentOrder(): boolean { return this._shallShowCretePaymentOrder; } private _shallShowCretePaymentOrder: boolean;
    private _parent: PaymentOrdersListViewModel;

    toggleDetail() {
        this.showDetail = !this.showDetail;
    }

    async createPaymentOrder() {
        let vm = new CreatePaymentOrderViewModel(this, this.processId);
        let result = await this.requestShowingPopup(vm);
        if (result == 'yes') {
            this._parent.refresh();
        }
    }

    updateShowingActions() {
        if (this.status == 1) {
            this.shallShowCretePaymentOrder = true;
        } else {
            this.shallShowCretePaymentOrder = false;
        }
    }

}

export class attachment extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);
        this.downloader = new AttachmentDownloader();
    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set downloader(v: AttachmentDownloader) { this._downloader = v; } public get downloader(): AttachmentDownloader { return this._downloader; } private _downloader: AttachmentDownloader;

}